<section class="flex h-full flex-col rounded-2xl bg-neutral-3 p-4" aria-labelledby="customers-title">
  <header class="mb-2 flex flex-wrap items-center gap-3 px-6 py-2">
    <h2 id="customers-title" class="text-4xl font-bold">Customers</h2>
    @if (total.hasValue()) {
      <span class="text-lg text-gray-500 tabular-nums">{{ total.value() | number }}</span>
    }
    <div class="ml-auto flex items-center gap-2">
      <app-customer-sort-select [value]="sort()" (valueChange)="sortBy($event)" />
      <app-sort-direction-toggle
        [direction]="direction()"
        (directionChange)="reverse($event)"
        [ascLabel]="sortOption().asc"
        [descLabel]="sortOption().desc"
      />
    </div>
  </header>

  <div #scroller class="min-h-0 flex-1 overflow-auto">
    @if (page.error()) {
      <div class="flex flex-col items-center gap-3 p-8 text-center text-gray-500" role="alert">
        <p>Couldn't load customers.</p>
        <button
          type="button"
          class="rounded-full bg-button-primary px-4 py-2 text-sm text-white shadow hover:bg-button-primary-hover"
          (click)="page.reload()"
        >
          Try again
        </button>
      </div>
    } @else if (page.hasValue()) {
      @if (customers().length === 0) {
        <p class="p-8 text-center text-gray-500">No customers yet.</p>
      } @else {
        <ul
          class="flex flex-col gap-2 transition-opacity"
          [class.opacity-50]="page.isLoading()"
          [attr.aria-busy]="page.isLoading()"
        >
          @for (customer of customers(); track customer.id) {
            <li>
              <a
                class="block rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-button-primary"
                [routerLink]="customer.id"
              >
                <app-customer-item [customer]="customer" />
              </a>
            </li>
          }
        </ul>
      }
    } @else {
      <ul class="flex flex-col gap-2" aria-busy="true" aria-label="Loading customers">
        @for (row of skeletonRows; track row) {
          <li class="h-[4.5rem] animate-pulse rounded-lg bg-white/70"></li>
        }
      </ul>
    }
  </div>

  @if (hasPrevious() || hasNext()) {
    <nav class="flex items-center justify-between gap-4 px-2 pt-4" aria-label="Customer pages">
      <span class="text-sm text-gray-500 tabular-nums">
        @if (range(); as r) {
          {{ r.first | number }}–{{ r.last | number }}
          @if (total.hasValue()) {
            of {{ total.value() | number }}
          }
        }
      </span>

      <div class="flex items-center gap-3">
        <button
          type="button"
          class="rounded-full border border-gray-200 bg-white px-4 py-2 text-sm shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
          [disabled]="!hasPrevious() || page.isLoading()"
          (click)="previous()"
          aria-label="Previous page"
        >
          Previous
        </button>
        <span class="text-sm text-gray-700 tabular-nums" aria-live="polite">
          Page {{ pageIndex() + 1 }}
          @if (pageCount(); as count) {
            of {{ count }}
          }
        </span>
        <button
          type="button"
          class="rounded-full border border-gray-200 bg-white px-4 py-2 text-sm shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
          [disabled]="!hasNext() || page.isLoading()"
          (click)="next()"
          aria-label="Next page"
        >
          Next
        </button>
      </div>
    </nav>
  }
</section>
